import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ErrorMessages } from '@smarsh-cyber/shared/constants';
import { ReqStatus } from '@smarsh-cyber/shared/models';
import { GetLoginOtpRES } from '../models/api_models/passcode/get-login-otp.res';
import { VerifyLoginOtpRES } from '../models/api_models/passcode/verify-login-otp.res';
import {
  GetLoginOTPModel,
  VerifyLoginOTPModel
} from '../models/ui_models/passcode/otp-login';

export const translateGetLoginOtpRes = (
  apiResponse: GetLoginOtpRES
): GetLoginOTPModel => {
  return {
    data: {
      session: apiResponse.data.session
    },
    errors: [],
    pageState: null,
    reqState: {
      httpCode: null,
      modalStatus: null,
      message: '',
      cyberCode: 0,
      reqStatus: ReqStatus.SUCCESS
    }
  };
};

export const translateVerifyLoginOtpRes = (
  apiResponse: VerifyLoginOtpRES
): VerifyLoginOTPModel => {
  return {
    data: {
      accessToken: apiResponse.data.accessToken,
      refreshToken: apiResponse.data.refreshToken
    },
    errors: [],
    pageState: null,
    reqState: {
      httpCode: null,
      modalStatus: null,
      message: apiResponse?.message,
      cyberCode: apiResponse?.cyberCode,
      reqStatus: ReqStatus.SUCCESS
    }
  };
};

export const translateGetLoginOtpErrorRes = (
  apiResponse: HttpErrorResponse
): GetLoginOTPModel => {
  let message = '';
  const status = apiResponse?.status;
  switch (status) {
    case HttpStatusCode.Unauthorized:
    case HttpStatusCode.BadRequest:
      message = ErrorMessages.INVALID_USER;
      break;
    case HttpStatusCode.Forbidden:
      message = apiResponse?.error?.message;
      break;
    default:
      message = ErrorMessages.GENERIC_ERROR;
  }

  return {
    data: null,
    errors: [
      {
        message: apiResponse.message,
        status: apiResponse.status
          ? HttpStatusCode.Ok
          : HttpStatusCode.InternalServerError
      }
    ],
    pageState: null,
    reqState: {
      httpCode: apiResponse.status,
      modalStatus: null,
      message,
      cyberCode: 0, //TODO
      reqStatus: ReqStatus.ERROR
    }
  };
};

export const translateVerifyLoginOTPErrorRes = (
  apiResponse: HttpErrorResponse
): VerifyLoginOTPModel => {
  let message = '';
  const status = apiResponse?.status;
  switch (status) {
    case HttpStatusCode.Unauthorized:
    case HttpStatusCode.BadRequest:
      message = ErrorMessages.INVALID_OTP;
      break;
    case HttpStatusCode.Forbidden:
      message = apiResponse?.error?.message;
      break;
    default:
      message = ErrorMessages.GENERIC_ERROR;
  }

  return {
    data: null,
    errors: [
      {
        message: apiResponse.message,
        status: apiResponse.status
          ? HttpStatusCode.Ok
          : HttpStatusCode.InternalServerError
      }
    ],
    pageState: null,
    reqState: {
      httpCode: apiResponse.status,
      modalStatus: null,
      message,
      cyberCode: 0, //TODO
      reqStatus: ReqStatus.ERROR
    }
  };
};
